export class EditStyleModel {
	public static checkbox = 'checkbox';
	public static time24 = 'time_24';
	public static timeAmPm = 'time_ampm';
	public static signature = 'signature';
	public static gps = 'GPS';
}
